import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12, default as _styled13, default as _styled14, default as _styled15, default as _styled16, default as _styled17, default as _styled18, default as _styled19, default as _styled20, default as _styled21, default as _styled22, default as _styled23, default as _styled24, default as _styled25, default as _styled26, default as _styled27, default as _styled28 } from "styled-components";
import React from "react";
import { hasItems, takeFirst } from "~/features/app/utils";
import { Wrap } from "~/features/ui/wrap";
import { Headline } from "~/features/ui/headline";
import { Button } from "~/features/ui/button";
import { Link } from "~/features/ui/link";
import { isLinkValid } from "~/features/ui/link/utils";
import { useContentGallery, AUTOPLAY_DURATION } from "./use-content-gallery";
const Section = _styled.section.withConfig({
  componentId: "sc-sf-ntpg0g-0"
})`
  ${{
  "overflow": "hidden"
}}

  @keyframes cardFill {
    from {
      transform: scaleX(0);
    }
    to {
      transform: scaleX(1);
    }
  }
`;
var _StyledSection = _styled2(Section).withConfig({
  componentId: "sc-sf-ntpg0g-1"
})`${p => p.$_css}`;
type SectionDataAttrs = Record<`data-${string}`, string | undefined>;
type PlainLink = Record<string, unknown> & {
  href?: string;
  newWindow?: boolean;
  text?: React.ReactNode;
};
export type ContentGalleryBlockSpec = {
  label?: string | null;
  value?: string | null;
};
export type ContentGalleryBlockViewItem<TSpec = ContentGalleryBlockSpec> = {
  description?: React.ReactNode;
  link?: PlainLink | Array<PlainLink | null | undefined> | null;
  media?: React.ReactNode;
  specs?: TSpec[] | null;
  title?: string | null;
};
export type ContentGalleryBlockViewProps<TSpec extends ContentGalleryBlockSpec = ContentGalleryBlockSpec, TItem extends ContentGalleryBlockViewItem<TSpec> = ContentGalleryBlockViewItem<TSpec>> = {
  anchor?: Array<{
    id?: string | null;
    name?: string | null;
  }> | {
    id?: string | null;
    name?: string | null;
  } | null;
  getItemKey?: (item: TItem, index: number) => React.Key;
  getSpecKey?: (spec: TSpec, index: number) => React.Key;
  hasCounters?: boolean | null;
  hasTopDivider?: boolean | null;
  isHighlighted?: boolean | null;
  items?: TItem[] | null;
  mode?: string | null;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & SectionDataAttrs;
  theme?: string | null;
};
export function ContentGalleryBlockView<TSpec extends ContentGalleryBlockSpec = ContentGalleryBlockSpec, TItem extends ContentGalleryBlockViewItem<TSpec> = ContentGalleryBlockViewItem<TSpec>>({
  anchor,
  getItemKey,
  getSpecKey,
  hasCounters = false,
  hasTopDivider = true,
  isHighlighted = false,
  items = [],
  mode = "light",
  sectionProps,
  theme = "white"
}: ContentGalleryBlockViewProps<TSpec, TItem>) {
  const entries = items ?? [];
  const {
    activeIndex,
    isExpanded,
    contentRef,
    mediaContainerRef,
    accordionRef,
    changeSlide,
    handleAutoAdvance,
    toggleAccordion
  } = useContentGallery(entries.length);
  if (!hasItems(entries)) {
    return null;
  }
  const activeItem = entries[activeIndex];
  const activeLink = takeFirst(activeItem?.link);
  return <_StyledSection {...sectionProps} data-theme={mode} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} $_css={[{
    "position": "relative",
    "color": "var(--text-primary)"
  }, theme === "grey" ? {
    "backgroundColor": "var(--bg-secondary)"
  } : {
    "backgroundColor": "var(--bg-primary)"
  }, isHighlighted && {
    "backgroundColor": "var(--white-static)"
  }]}>
      <_StyledWrap>
        <_StyledDiv role="list" className="hide-scrollbar" $_css2={[{
        "display": "flex",
        "overflowX": "auto",
        "borderTopWidth": "1px",
        "borderColor": "var(--stroke-primary)",
        "@media (min-width: 1024px)": {
          "paddingLeft": "var(--spacing-xl)",
          "paddingRight": "var(--spacing-xl)"
        }
      }]}>
          {entries.map((item, idx) => {
          const isActive = idx === activeIndex;
          return <_StyledButton key={getItemKey?.(item, idx) || idx} role="listitem" type="button" onClick={() => changeSlide(idx)} $_css3={[{
            "position": "relative",
            "display": "flex",
            "cursor": "pointer",
            "gap": "var(--spacing-lg)",
            "whiteSpace": "nowrap",
            "paddingLeft": "var(--spacing-lg)",
            "paddingRight": "var(--spacing-lg)",
            "paddingTop": "var(--spacing-lg)",
            "paddingBottom": "var(--spacing-lg)",
            "transitionProperty": "opacity",
            "transitionDuration": "250ms",
            "@media (min-width: 1024px)": {
              "paddingLeft": "0",
              "paddingRight": "0"
            }
          }, {
            "fontSize": "1.6rem",
            "lineHeight": "1.5",
            "fontWeight": "400",
            "@media (min-width: 1024px)": {
              "fontSize": "1.8rem",
              "lineHeight": "1.5",
              "letterSpacing": "0.018rem",
              "fontWeight": "400"
            }
          }, entries.length === 2 && {
            "@media (min-width: 1024px)": {
              "width": "50%"
            }
          }, entries.length === 3 && {
            "@media (min-width: 1024px)": {
              "width": "33.3333%"
            }
          }, entries.length >= 4 && {
            "@media (min-width: 1024px)": {
              "width": "25%"
            }
          }, isActive ? {
            "opacity": "1"
          } : {
            "opacity": "0.4"
          }]}>
                {isActive && <_StyledDiv2 style={{
              backgroundColor: "rgba(0, 82, 255, 0.24)"
            }} $_css4={[{
              "position": "absolute",
              "bottom": "0",
              "left": "0",
              "right": "0",
              "height": "0.1rem"
            }]}>
                    <_StyledDiv3 key={activeIndex} style={{
                animation: `cardFill ${AUTOPLAY_DURATION}ms linear forwards`
              }} $_css5={[{
                "height": "100%",
                "transformOrigin": "left",
                "--tw-bg-opacity": "1",
                "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
              }]} />
                  </_StyledDiv2>}
                <_StyledSpan $_css6={[{
              "display": "none",
              "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
              "fontSize": "1.4rem",
              "@media (min-width: 1024px)": {
                "display": "inline"
              }
            }]}>0{idx + 1}</_StyledSpan> {item.title}
              </_StyledButton>;
        })}
        </_StyledDiv>

        <_StyledDiv4 $_css7={[{
        "padding": "var(--spacing-md)",
        "@media (min-width: 1024px)": {
          "padding": "var(--spacing-xl)"
        }
      }, hasTopDivider && {
        "borderTopWidth": "1px",
        "borderColor": "var(--stroke-primary)"
      }]}>
          <_StyledDiv5 ref={mediaContainerRef} $_css8={[{
          "position": "relative",
          "display": "flex",
          "height": "60rem",
          "alignItems": "flex-end",
          "overflow": "hidden",
          "borderRadius": "4px",
          "--tw-bg-opacity": "1",
          "backgroundColor": "rgb(69 69 69 / var(--tw-bg-opacity))",
          "padding": "var(--spacing-md)",
          "@media (min-width: 1024px)": {
            "height": "69rem"
          }
        }]}>
            {entries.map((item, idx) => {
            return <_StyledDiv6 key={getItemKey?.(item, idx) || idx} data-media-idx={idx} style={{
              opacity: idx === activeIndex ? 1 : 0,
              transition: "opacity 1000ms cubic-bezier(0.4, 0, 0.2, 1)"
            }} $_css9={[{
              "position": "absolute",
              "inset": "0",
              "overflow": "hidden"
            }]}>
                  {item.media && <_StyledDiv7 data-zoom $_css10={[{
                "height": "100%",
                "width": "100%"
              }]}>
                      {item.media}
                    </_StyledDiv7>}
                </_StyledDiv6>;
          })}

            <_StyledDiv8 ref={contentRef} data-theme="dark" $_css11={[{
            "position": "relative",
            "zIndex": "10",
            "display": "flex",
            "height": "auto",
            "flexDirection": "column",
            "justifyContent": "space-between",
            "alignSelf": "flex-end",
            "backgroundColor": "rgba(0, 7, 4, 0.2)",
            "padding": "var(--spacing-md)",
            "--tw-text-opacity": "1",
            "color": "rgb(255 255 255 / var(--tw-text-opacity))",
            "--tw-backdrop-blur": "blur(16px)",
            "backdropFilter": "var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia)",
            "@media (min-width: 1024px)": {
              "height": "100%",
              "width": "48rem",
              "padding": "var(--spacing-lg)"
            }
          }]}>
              <_StyledDiv9 style={{
              backgroundColor: "rgba(0, 82, 255, 0.24)"
            }} $_css12={[{
              "position": "absolute",
              "left": "0",
              "right": "0",
              "top": "0",
              "zIndex": "20",
              "display": "none",
              "height": "0.4rem",
              "width": "100%",
              "@media (min-width: 1024px)": {
                "display": "block"
              }
            }]}>
                <_StyledDiv10 key={activeIndex} style={{
                animation: `cardFill ${AUTOPLAY_DURATION}ms linear forwards`
              }} onAnimationEnd={handleAutoAdvance} $_css13={[{
                "height": "100%",
                "transformOrigin": "left",
                "--tw-bg-opacity": "1",
                "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
              }]} />
              </_StyledDiv9>

              <_StyledButton2 type="button" onClick={toggleAccordion} data-animate="title" $_css14={[{
              "display": "flex",
              "width": "100%",
              "alignItems": "center",
              "justifyContent": "space-between",
              "gap": "var(--spacing-md)",
              "textAlign": "left",
              "@media (min-width: 1024px)": {
                "pointerEvents": "none"
              }
            }]}>
                {activeItem?.title && <_StyledHeadline type="h2" text={activeItem.title} />}
                <_StyledSpan2 $_css15={[{
                "position": "relative",
                "display": "flex",
                "height": "4rem",
                "width": "4rem",
                "flexShrink": "0",
                "alignItems": "center",
                "justifyContent": "center",
                "borderRadius": "2px",
                "--tw-bg-opacity": "1",
                "backgroundColor": "rgb(108 112 97 / var(--tw-bg-opacity))",
                "@media (min-width: 1024px)": {
                  "display": "none"
                }
              }]}>
                  <_StyledSpan3 style={{
                  width: 6,
                  height: 1
                }} $_css16={[{
                  "position": "absolute",
                  "backgroundColor": "currentColor"
                }]} />
                  <_StyledSpan4 style={{
                  width: 6,
                  height: 1,
                  transform: isExpanded ? "rotate(0deg)" : "rotate(90deg)"
                }} $_css17={[{
                  "position": "absolute",
                  "backgroundColor": "currentColor",
                  "transitionProperty": "transform",
                  "transitionDuration": "250ms",
                  "transitionTimingFunction": "ease-in-out"
                }]} />
                </_StyledSpan2>
              </_StyledButton2>

              <_StyledDiv11 ref={accordionRef} style={{
              height: 0,
              opacity: 0
            }} $_css18={[{
              "overflow": "hidden",
              "@media (min-width: 1024px)": {
                "height": "auto !important",
                "overflow": "visible !important",
                "opacity": "1 !important"
              }
            }]}>
                <_StyledDiv12 $_css19={[{
                "display": "flex",
                "flexDirection": "column",
                "alignItems": "flex-start",
                "gap": "var(--spacing-lg)",
                "paddingTop": "var(--spacing-xl)",
                "@media (min-width: 1024px)": {
                  "gap": "var(--spacing-xl)",
                  "paddingTop": "0"
                }
              }]}>
                  {activeItem?.description && <div data-animate="description">{activeItem.description}</div>}
                  {hasItems(activeItem?.specs) && <_StyledDiv13 data-animate="specs" $_css20={[{
                  "display": "flex",
                  "width": "100%",
                  "flexDirection": "column",
                  "gap": "var(--spacing-md)",
                  "@media (min-width: 1024px)": {
                    "flexDirection": "row"
                  }
                }]}>
                      {activeItem.specs.map((spec, idx) => <_StyledDiv14 key={getSpecKey?.(spec, idx) || idx} $_css21={[{
                    "flex": "1 1 0%"
                  }]}>
                          <_StyledDiv15>
                            {hasCounters && <_StyledSpan5>
                                0{idx + 1}
                              </_StyledSpan5>}
                            {spec.label && <_StyledSpan6>
                                {spec.label}
                              </_StyledSpan6>}
                            {spec.value && <_StyledSpan7>{spec.value}</_StyledSpan7>}
                          </_StyledDiv15>
                        </_StyledDiv14>)}
                    </_StyledDiv13>}
                  {isLinkValid(activeLink) && <div data-animate="cta">
                      <Button as={Link} {...activeLink} variant="underline" />
                    </div>}
                </_StyledDiv12>
              </_StyledDiv11>
            </_StyledDiv8>
          </_StyledDiv5>
        </_StyledDiv4>
      </_StyledWrap>
    </_StyledSection>;
}
var _StyledWrap = _styled3(Wrap).withConfig({
  componentId: "sc-sf-ntpg0g-2"
})({
  "display": "flex",
  "flexDirection": "column",
  "borderWidth": "0px"
});
var _StyledDiv = _styled4("div").withConfig({
  componentId: "sc-sf-ntpg0g-3"
})`${p => p.$_css2}`;
var _StyledButton = _styled5("button").withConfig({
  componentId: "sc-sf-ntpg0g-4"
})`${p => p.$_css3}`;
var _StyledDiv2 = _styled6("div").withConfig({
  componentId: "sc-sf-ntpg0g-5"
})`${p => p.$_css4}`;
var _StyledDiv3 = _styled7("div").withConfig({
  componentId: "sc-sf-ntpg0g-6"
})`${p => p.$_css5}`;
var _StyledSpan = _styled8("span").withConfig({
  componentId: "sc-sf-ntpg0g-7"
})`${p => p.$_css6}`;
var _StyledDiv4 = _styled9("div").withConfig({
  componentId: "sc-sf-ntpg0g-8"
})`${p => p.$_css7}`;
var _StyledDiv5 = _styled10("div").withConfig({
  componentId: "sc-sf-ntpg0g-9"
})`${p => p.$_css8}`;
var _StyledDiv6 = _styled11("div").withConfig({
  componentId: "sc-sf-ntpg0g-10"
})`${p => p.$_css9}`;
var _StyledDiv7 = _styled12("div").withConfig({
  componentId: "sc-sf-ntpg0g-11"
})`${p => p.$_css10}`;
var _StyledDiv8 = _styled13("div").withConfig({
  componentId: "sc-sf-ntpg0g-12"
})`${p => p.$_css11}`;
var _StyledDiv9 = _styled14("div").withConfig({
  componentId: "sc-sf-ntpg0g-13"
})`${p => p.$_css12}`;
var _StyledDiv10 = _styled15("div").withConfig({
  componentId: "sc-sf-ntpg0g-14"
})`${p => p.$_css13}`;
var _StyledButton2 = _styled16("button").withConfig({
  componentId: "sc-sf-ntpg0g-15"
})`${p => p.$_css14}`;
var _StyledHeadline = _styled17(Headline).withConfig({
  componentId: "sc-sf-ntpg0g-16"
})({
  "fontSize": "2.4rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "3.8rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.038rem",
    "fontWeight": "400"
  }
});
var _StyledSpan2 = _styled18("span").withConfig({
  componentId: "sc-sf-ntpg0g-17"
})`${p => p.$_css15}`;
var _StyledSpan3 = _styled19("span").withConfig({
  componentId: "sc-sf-ntpg0g-18"
})`${p => p.$_css16}`;
var _StyledSpan4 = _styled20("span").withConfig({
  componentId: "sc-sf-ntpg0g-19"
})`${p => p.$_css17}`;
var _StyledDiv11 = _styled21("div").withConfig({
  componentId: "sc-sf-ntpg0g-20"
})`${p => p.$_css18}`;
var _StyledDiv12 = _styled22("div").withConfig({
  componentId: "sc-sf-ntpg0g-21"
})`${p => p.$_css19}`;
var _StyledDiv13 = _styled23("div").withConfig({
  componentId: "sc-sf-ntpg0g-22"
})`${p => p.$_css20}`;
var _StyledDiv14 = _styled24("div").withConfig({
  componentId: "sc-sf-ntpg0g-23"
})`${p => p.$_css21}`;
var _StyledDiv15 = _styled25("div").withConfig({
  componentId: "sc-sf-ntpg0g-24"
})({
  "display": "flex",
  "flexDirection": "row",
  "gap": "var(--spacing-sm)",
  "borderTopWidth": "1px",
  "borderColor": "rgba(255, 255, 255, 0.1)",
  "paddingTop": "var(--spacing-md)",
  "@media (min-width: 1024px)": {
    "flexDirection": "column",
    "borderTopWidth": "0px",
    "paddingTop": "0"
  }
});
var _StyledSpan5 = _styled26("span").withConfig({
  componentId: "sc-sf-ntpg0g-25"
})({
  "minWidth": "8rem",
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.4rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.028000000000000004rem",
  "fontWeight": "400",
  "color": "var(--text-transparent)",
  "@media (min-width: 1024px)": {
    "fontSize": "1.6rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.032rem",
    "fontWeight": "400"
  }
});
var _StyledSpan6 = _styled27("span").withConfig({
  componentId: "sc-sf-ntpg0g-26"
})({
  "minWidth": "8rem",
  "fontSize": "2.8rem",
  "lineHeight": "1.2",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "4.4rem",
    "lineHeight": "1.3",
    "letterSpacing": "0.044rem",
    "fontWeight": "400"
  }
});
var _StyledSpan7 = /*#__PURE__*/_styled28("span").withConfig({
  displayName: "content-gallery___StyledSpan7",
  componentId: "sc-1aqa4nl-0"
})({
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "400"
  }
});